module.exports = __webpack_public_path__ + "img/kong.eb408cba.png";